import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import "../../Styles.scss";
import "../../login.scss";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { roles } from "../../utils/constants";
import { Toast } from '../../shared/Toast'
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import AuthCode from "react-auth-code-input";
import BrowserFingerprint from "../../utils/FingerPrint";
import { useCookies } from "react-cookie";
import { Setb2b_permissions } from '../../redux/counterSlice';
import { useDispatch, useSelector } from 'react-redux';
import CryptoJS from 'crypto-js'
import config from '../../config.js';
import { SlIcon, SlInput } from "@shoelace-style/shoelace/dist/react";

let logerr = "";

function Login() {
  const [showOtpError, setShowOtpError] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [bfp, setBfp] = useState();
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);
  const [result, setResult] = useState();
  const [frequency, setFrequency] = useState()
  const [advId, setAdvId] = useState("")


  const handleOnChange = (res) => {
    setResult(res);
  };

  const [showPswd, setShowPswd] = useState(false);
  const [forgotPswd, setForgotPswd] = useState(false);
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/i;

  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);

  const navigating = (role) => {
    console.log("I am here bro!")
    console.log("role",role)
    if (role === roles.ops) navigate("/home/order");
    else if (role === roles.salesperson) {
      if(localStorage.getItem('discount-obj')?.length > 0){
        navigate(`/home/discount/${localStorage.getItem('discount-obj')}`)
      }
      else if(localStorage.getItem('slot-id')?.length > 0){
        navigate(`/home/slotbooking/${localStorage.getItem('slot-id')}`)
      }
      else
      navigate("/home/sales/dashboard");
    } else if (role === roles.financer) navigate("/home/order");
    else if (role === roles.advertiser) navigate("/home/dashboard");
    else if (role === roles.content_writer) navigate("/home/content_writer")
    else if(role === roles.designer) navigate("/home/designer");
    else if (role === roles.network_ad_manager)
      navigate("/home/networkads/queued");
    else if (role === roles.legalperson) {
      if(localStorage.getItem('discount-obj')?.length > 0){
        navigate(`/home/discount/${localStorage.getItem('discount-obj')}`)
      }else
      navigate("/home/order");
    } else if (role === roles.b2b && localStorage.getItem("b2b")) {
      const encryptedPermissions = localStorage.getItem("b2b");

      // Decrypt the permissions with the same secret key
      const decryptedPermissionsBytes = CryptoJS.AES.decrypt(
        encryptedPermissions,
        config.B2B_SECRET_KEY
      );

      // Convert the decrypted bytes back to a JSON string
      const decryptedPermissionsJSON = decryptedPermissionsBytes.toString(
        CryptoJS.enc.Utf8
      );

      // Parse the JSON string to get the original object
      const b2b_permissions = JSON.parse(decryptedPermissionsJSON)[0];

      if (b2b_permissions.newspaperData) {
        navigate("/home/competitor_data/get");
      } else if (b2b_permissions.b2bData) {
        navigate("/home/b2b_contacts/get");
      } else if (b2b_permissions.agencyData) {
        navigate("/home/agency_data/get");
      } else if (b2b_permissions.competitorData) {
        navigate("/home/competitor_reports/get");
      } else if (b2b_permissions.requests) {
        navigate("/home/b2b_requests/get");
      } else {
        navigate("/home/competitor_data/get");
      }
    } else {
      navigate("/pagenotfound");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token") && cookies.bfp) {

      navigating(localStorage.getItem("role"));
    }
    else {
      localStorage.removeItem('token')
    }
  }, []);


  const formirk = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .required("Username is required")
        .test(
          "is-valid-username",
          "Username must be a valid email address or phone number",
          function (value) {
            const emailRegex =
              /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/i;
            const phoneRegex = /^[6-9]\d{9}$/;
            return emailRegex.test(value) || phoneRegex.test(value);
          }
        ),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async (values) => {
      setTimeout(() => {
        logerr = "";
      }, 500);
      try {
        let res = await api({
          url: `/login`,
          method: "POST",
          responseType: "json",
          data: values,
        });
        if (res.message === "Login Successfull") {
          localStorage.setItem("token", res.data.authorization);
          localStorage.setItem("role", res.data.role);
          localStorage.setItem("name", res.data.name);
          localStorage.setItem("expiry", res.data.expiry);
          localStorage.setItem("email", res.data.email);
          localStorage.setItem("show", true);
          localStorage.setItem("type", res.data.type)
          if(res.data?.role === roles.salesperson && res?.data?.team){
            const encryptedTeam = CryptoJS.AES.encrypt(res?.data?.team, config.B2B_SECRET_KEY).toString();
            localStorage.setItem("sales_team", encryptedTeam);
          }
          if (res.data.type !== "mediaPartner") {
            logerr = "";
            if (res.data.role === roles.b2b) {
              const permissionsJSON = JSON.stringify(res.data.b2b_permissions);

              const encryptedPermissions = CryptoJS.AES.encrypt(permissionsJSON, config.B2B_SECRET_KEY).toString();

              localStorage.setItem("b2b", encryptedPermissions);
            } 
            if (cookies.bfp) {
              let response = await validatefp();
              if (response) {
                if (localStorage.getItem('role') === roles.salesperson) {
                  const headDetails = await api({
                    url: `/user/sales_persons/headDetails`,
                    method: "POST",
                    responseType: "json"
                  });
                  if (headDetails.data) {
                    const userData = headDetails.data
                    let userType = ""
                    if (userData.user_type === -1)
                      userType = "Main"
                    else if (userData.user_type === 1 && userData.region === -1 && userData.location === -1)
                      userType = "NationalHead"
                    else if (userData.user_type === 2 && userData.region === -1 && userData.location === -1)
                      userType = "LocalHead"
                    else if (userData.user_type === 1 && userData.region !== -1 && userData.location === -1)
                      userType = "RegionHead"
                    if (userType === "Main" || userType === "NationalHead" || userType === "LocalHead" || userType === "RegionHead") {
                      let encryptedSalesTabPermissions = CryptoJS.AES.encrypt(userType, config.B2B_SECRET_KEY).toString();
                      localStorage.setItem('salesTabFlag', encryptedSalesTabPermissions)
                    }
                  }
                }
                if(res.data.main_user_permissions?.length){
                  const setAllUsersResult = await setUsersForMainUser(res.data.authorization, cookies.bfp);
                }
                navigating(localStorage.getItem("role"));
              } else {
                let result = await api({
                  url: "/login/sendOtp",
                  method: "POST",
                  responseType: "json",
                  data: {},
                });
                if (result.code === 200) {
                  setBfp(await BrowserFingerprint());
                  setShowOtp(true);
                  setFrequency(result.data)
                  if(res.data.main_user_permissions?.length){
                    localStorage.setItem('main_user', CryptoJS.AES.encrypt(JSON.stringify(true), config.B2B_SECRET_KEY).toString())
                  }
                }
                else if (result.data.code === 400) {
                  Toast("error", result.data.message)
                }
                else {
                  Toast("error", result.data.message)
                }
              }
            } else {
              let result = await api({
                url: "/login/sendOtp",
                method: "POST",
                responseType: "json",
                data: {},
              });
              if (result.code === 200) {
                setBfp(await BrowserFingerprint());
                setShowOtp(true);
                setFrequency(result.data)
                if(res.data.main_user_permissions?.length){
                  localStorage.setItem('main_user', CryptoJS.AES.encrypt(JSON.stringify(true), config.B2B_SECRET_KEY).toString())
                }
              }
              else {
                Toast("error", result.data.message)
              }

            }
          }
          else {
            setCookie("bfp", await BrowserFingerprint(), { path: "/", expires: expirationDate });
            navigating(localStorage.getItem('role'))
          }
        }
        else if (res.message === "AutoGenerated Password") {
          if (res.code === 200) {
            if (res?.data?.reset_pswd === 0) {
              setShowPswd(true);
              setAdvId(res?.data?.adv_id)
              setOldPswd(res?.data?.password)
            } else {
              setShowPswd(false)
            }
          } else {
            Toast("error", res.data.message)
          }
        }
        else {
          logerr = res.data.message;
        }
      } catch (error) {
        console.error(error);
        let er = error.response.message
          ? error.response.message
          : "Something went wrong";
        logerr = er;
      }
    },
  });
  const handleClose = () => {
    setShowOtp(false);
  };
  const OTPValidation = async (e) => {
    try {
      let res = await api({
        url: "/login/validateOtp",
        method: "POST",
        responseType: "json",
        data: {
          otp: result,
          fp: bfp
        },
      });
      if (res.code === 200) {
        Insertfp();
        setCookie("bfp", bfp, { path: "/", expires: expirationDate });
        if (localStorage.getItem('role') === roles.salesperson) {
          const headDetails = await api({
            url: `/user/sales_persons/headDetails`,
            method: "POST",
            responseType: "json"
          });
          if (headDetails.data) {
            const userData = headDetails.data
            let userType = ""
            if (userData.user_type === -1)
              userType = "Main"
            else if (userData.user_type === 1 && userData.region === -1 && userData.location === -1)
              userType = "NationalHead"
            else if (userData.user_type === 2 && userData.region === -1 && userData.location === -1)
              userType = "LocalHead"
            else if (userData.user_type === 1 && userData.region !== -1 && userData.location === -1)
              userType = "RegionHead"
            if (userType === "Main" || userType === "NationalHead" || userType === "LocalHead" || userType === "RegionHead") {
              let encryptedSalesTabPermissions = CryptoJS.AES.encrypt(userType, config.B2B_SECRET_KEY).toString();
              localStorage.setItem('salesTabFlag', encryptedSalesTabPermissions)
            }
          }
        }
        if(localStorage.getItem('role') === roles.ops){
          let encodeMainUser = localStorage.getItem('main_user')
          if(encodeMainUser){
            const decryptedMainUserPermission = CryptoJS.AES.decrypt(encodeMainUser, config.B2B_SECRET_KEY);
            let MainUserFlag = JSON.parse(decryptedMainUserPermission.toString(CryptoJS.enc.Utf8))
            if(MainUserFlag === true){
              const setAllUsersResult = await setUsersForMainUser(localStorage.getItem('token'), bfp);
            }
          }
        }
        navigating(localStorage.getItem("role"));
        setShowOtpError(false);
      } else {
        setShowOtpError(true);
        e.preventDefault();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleValidate = (e) => {
    e.preventDefault();
    if (result.length === 4) {
      OTPValidation(e);
    } else {
      setShowOtpError(true);
    }
  };

  const validatefp = async () => {
    try {
      let res = await api({
        url: "/login/validatefp",
        method: "POST",
        responseType: "json",
        data: {
          fp: cookies.bfp,
        },
      });
      if (res.code !== 200) {
        removeCookie("bfp");
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const Insertfp = async () => {
    try {
      let res = await api({
        url: "/login/bfp",
        method: "POST",
        responseType: "json",
        data: {
          bfp: bfp,
        },
      });
      if (res.code === 200) {
        console.log("Fingerprint saved succcesfully");
      }
      else{
        Toast('error', 'Unauthorized action')
        localStorage.removeItem('token')
        navigate('/')
      }
    } catch (error) {
      console.error(error);
    }
  };

  const setUsersForMainUser = async (authorization, bfp) => {
    try {
      const result = await api({
        url: 'mainuser/getMainUsers',
        method: 'POST',
        responseType: 'json',
        data: {
          authorization,
          bfp,
        }
      })
      if(result?.code === 200){
        let encryptedCSTuserPermissions = CryptoJS.AES.encrypt(JSON.stringify(result.data), config.B2B_SECRET_KEY).toString();
        if(result?.data.length)
          localStorage.setItem('main_user', encryptedCSTuserPermissions)
      }      
      return true
    } catch (error) {
      console.error("Error @ setUsersForMainUser", error)
    }
    
  }

  const updatePassword = async (oldPassword, newPassword, confirmPassword) => {
    try {
      let res = await api({
        url: "/login/updatePswd",
        method: "POST",
        responseType: "json",
        data: {
          old_pswd: oldPassword,
          new_pswd: newPassword,
          confirm_pswd: confirmPassword,
          department: roles.advertiser,
          adv_id: advId
        }

      });
      if (res.code === 200) {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setPasswordsMatch(true);
        setOldPswdMatch(true);
        setShowPswd(false);
        setOldPswd('');
        Toast("success", "Password reset successful")
      } else {
        Toast("error", res.data.message)
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [oldPswd, setOldPswd] = useState('');
  const [oldPswdMatch, setOldPswdMatch] = useState(true);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [forgotEmail, setForgotEmail] = useState("")
  const [flag, setFlag] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [forgotOTP, setForgotOTP] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [isValidOTP, setIsValidOTP] = useState(true);
  const [otp, setOtp] = useState("")
  const handlePswdValidate = async (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword && oldPswd === oldPassword) {
      await updatePassword(oldPassword, newPassword, confirmPassword);
      // console.log('Passwords match!');
    } else if (oldPswd !== oldPassword) {
      setOldPswdMatch(false)
    } else if (newPassword !== confirmPassword) {
      // Passwords don't match - show error message
      setPasswordsMatch(false);
    }

  };

  const handleEmailValidate = async (e) => {
    e.preventDefault();
    if (forgotEmail === "") {
      setErrorEmail(true);
      setIsValidEmail(true);
      setOtpError(false);
      setIsValidOTP(true);
      return;
    }
    else if (!emailRegex.test(forgotEmail)) {
      setIsValidEmail(false);
      setErrorEmail(false);
      setOtpError(false);
      setIsValidOTP(true);
      return;
    } else {
      await forgotPswdOTP(forgotEmail)
      setFlag("OTP");
      setOtpError(false);
      setIsValidOTP(true);

    }
  }

  const handleOTPValidate = async (e) => {
    e.preventDefault();
    if (forgotOTP === "") {
      setOtpError(true)
      setErrorEmail(false);
      setIsValidEmail(true);
      setIsValidOTP(true);
    } else if (forgotOTP) {
      try {
        let res = await api({
          url: "/login/validateForgotOtp",
          method: "POST",
          responseType: "json",
          data: {
            otp: forgotOTP,
            email: forgotEmail
          },
        });
        if (res?.code === 200) {
          if (res?.data === "Valid") {
            setFlag("PasswordChange")
          } else if (res?.data === "Invalid") {
            setOtpError(false);
      setErrorEmail(false);
      setIsValidEmail(true);
      setIsValidOTP(false);
          }
        } else {
          console.log(res?.data?.message)
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  const forgotPswdOTP = async (forgotEmail) => {
    try {
      let res = await api({
        url: "/login/forgotPswdOtp",
        method: "POST",
        responseType: "json",
        data: {
          email: forgotEmail
        }

      });
      if (res.code === 200) {
        setOtp(res?.data)
      } else {
        Toast("error", res?.data?.message)
      }
    }
    catch (error) {
      console.error(error);
    }
  }

  const handleForgotPswdValidate = async (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      await forgotPassword(newPassword, confirmPassword);
      // console.log('Passwords match!');
    } else if (newPassword !== confirmPassword) {
      // Passwords don't match - show error message
      setPasswordsMatch(false);
    }

  };

  const forgotPassword = async (newPassword, confirmPassword) => {
    try {
      let res = await api({
        url: "/login/changePswd",
        method: "POST",
        responseType: "json",
        data: {
          email: forgotEmail,
          new_pswd: newPassword,
          confirm_pswd: confirmPassword,

        }

      });
      if (res?.code === 200) {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setPasswordsMatch(true);
        setOldPswdMatch(true);
        setShowPswd(false);
        setOldPswd('');
        setIsValidEmail(true);
        setForgotEmail('');
        setFlag('');
        setErrorEmail(false);
        setForgotOTP('');
        setOtpError(false);
        setIsValidOTP(true);
        setOtp('');
        if (res?.data) {
          setShowPswd(false);
          setForgotPswd(false)
          Toast("success", "Password reset successful")
        } else {
          navigate('/')
          Toast("error", "Account not found with given email ")
        }
      } else {
        Toast("error", res?.data?.message)
      }
    }
    catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <main className="d-flex align-items-center min-vh-100 py-3 py-md-0">
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-xxl-9 col-lg-8 col-md-7 mobHide">
              <div className="auth-bg pt-md-5 p-4 d-flex">
                {/* <img src="../images/login.jpg" alt="login" className="login-card-img" /> */}
                <div className="bg-overlay bg-primary"></div>
                <ul class="bg-bubbles">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <div className="h-screen flex items-center justify-center">
                  <div className="col-xl-7">
                    <div className="p-0 p-sm-4 px-xl-0 p-rel">
                      <i class="bx bxs-quote-alt-left text-success display-6"></i>
                      <span className="w-m">
                        India’s #1 Premium Language News App
                      </span>
                      <h4 className="mt-4 fw-medium lh-base text-white">
                        {" "}
                        Way2News is India’s Largest Engaged News App with
                        Premium High Net Worth language audience. With 15
                        Billion views a month, our engagement is 10 times the
                        entire Indian population.
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-5">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <img
                        src="../images/way2news.png"
                        alt="logo"
                        className="logo"
                      />
                    </div>

                    <div className="auth-content my-auto-1">
                      <div class="text-center">
                        <h5 class="mb-0">Welcome Back !</h5>
                        <p class="text-muted mt-2">{((!showPswd && !forgotPswd)) ? ("Sign into your account") : (forgotPswd ? ("Forgot Password") : "Reset your Password")}</p>
                      </div>

                      {((!showPswd && !forgotPswd) && flag === "") ? (<form onSubmit={formirk.handleSubmit}>
                        <div className="form-group mb-3">
                          <label htmlFor="name" className="sr-only">
                            Username
                          </label>
                          <SlInput
                            type="text"
                            name="username"
                            id="username"
                            placeholder="Email"
                            onSlInput={formirk.handleChange}
                            onBlur={formirk.handleBlur}
                            value={formirk.values.username}
                          />
                          <div>
                            <span>
                              {formirk.errors.username &&
                                formirk.touched.username ? (
                                <div style={{ color: "red" }}>
                                  {formirk.errors.username}
                                </div>
                              ) : null}
                            </span>
                          </div>
                        </div>
                        <div className="form-group mb-3 relative">
                          <label htmlFor="password" className="sr-only">
                            Password
                          </label>
                          <SlInput
                            type="password"
                            name="password"
                            id="password"
                            placeholder="***********"
                            onSlInput={formirk.handleChange}
                            onBlur={formirk.handleBlur}
                            value={formirk.values.password}
                            passwordToggle
                          />
                        
                          <div>
                            {formirk.errors.password &&
                              formirk.touched.password ? (
                              <div style={{ color: "red" }}>
                                {formirk.errors.password}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{logerr}</div>
                        <button type="button" className="forgot-pswd" onClick={() => { setForgotPswd(true) }}>
                          Forgot Password ?
                        </button>
                        <div className="d-grid gap-2">
                          <input
                            name="login"
                            id="login"
                            className="btn  login-button w-100 waves-effect waves-light"
                            type="submit"
                            value="Login"
                          />
                        </div>
                      </form>) : ((forgotPswd && flag === "") ? (<div><form onSubmit={handleEmailValidate}>
                        <div className="form-group mb-3">
                          <label htmlFor="newPassword" className="form-label">Email Address</label>
                          <input
                            type="text"
                            className="form-control"
                            id="forgotEmail"
                            name="forgotEmail"
                            value={forgotEmail}
                            placeholder="Enter Email address"
                            onChange={(e) => setForgotEmail(e.target.value)}
                          />
                        </div>
                        {errorEmail && (
                          <p className="text-danger m-1">Please enter your email address.</p>
                        )}
                        <p>We’ll send a verification code to this email if it matches an existing account. </p>
                        {!isValidEmail && (
                          <p className="text-danger m-1">Please enter a valid email address.</p>
                        )}
                        <button type="submit" className="btn  login-button w-100 waves-effect waves-light mb-3">
                          Next
                        </button>
                        <button type="button" className="back-button" onClick={() => { setForgotPswd(false); setShowPswd(false); setFlag(""); setErrorEmail(false); setIsValidEmail(true); setOtpError(false); setForgotEmail(""); setIsValidOTP(true); }}>
                          Back
                        </button>
                      </form></div>) : ((showPswd && flag === "") ? (<div>
                        <form onSubmit={handlePswdValidate}>
                          <div className="form-group mb-3">
                            <label htmlFor="oldPassword" className="form-label">Old Password</label>
                            <input
                              type="password"
                              className="form-control"
                              id="oldPassword"
                              name="oldPassword"
                              value={oldPassword}
                              onChange={(e) => setOldPassword(e.target.value)}
                              required
                            />
                          </div>
                          {!oldPswdMatch && (
                            <p className="text-danger m-1">Old Password that you have entered is Incorrect!</p>
                          )}
                          <div className="form-group mb-3">
                            <label htmlFor="newPassword" className="form-label">New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              id="newPassword"
                              name="newPassword"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              id="confirmPassword"
                              name="confirmPassword"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                            />
                          </div>
                          {!passwordsMatch && (
                            <p className="text-danger m-1">New Password and Confirm Password doesn't match!</p>
                          )}
                          <button type="submit" className="btn  login-button w-100 waves-effect waves-light">
                            Reset
                          </button>
                            </form>
                      </div>) : ((flag === "OTP") ? (<div><form onSubmit={handleOTPValidate}>
                        <div className="form-group mb-3">
                          <label htmlFor="newPassword" className="form-label">Enter the 4-digit code</label>
                          <input
                            type="text"
                            className="form-control"
                            id="forgotOTP"
                            name="forgotOTP"
                            value={forgotOTP}
                            placeholder="Enter 4-digit code"
                            onChange={(e) => setForgotOTP(e.target.value)}
                          />
                        </div>
                        {!isValidOTP && (
                          <p className="text-danger m-1">Please enter a valid OTP.</p>
                        )}
                        {otpError && (
                          <p className="text-danger m-1">Please enter OTP that have been sent to your registered email Address.</p>
                        )}
                        <button type="button" className="forgot-pswd" onClick={() => { forgotPswdOTP(forgotEmail); Toast("success", "We've sent you another code") }}>
                          Resend Code
                        </button>
                              <button type="submit" className="btn  login-button w-100 waves-effect waves-light mb-3">
                          Submit
                        </button>
                        <p>If you don't see a code in your inbox, check your spam folder. If it's not there, the email address may not be confirmed, or it may not match an existing account.</p>
                      </form></div>) : ((flag === "PasswordChange") ? (<div>
                        <form onSubmit={handleForgotPswdValidate}>
                          <div className="form-group mb-3">
                            <label htmlFor="newPassword" className="form-label">New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              id="newPassword"
                              name="newPassword"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                            <input
                              type="password"
                              className="form-control"
                              id="confirmPassword"
                              name="confirmPassword"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                            />
                          </div>
                          {!passwordsMatch && (
                            <p className="text-danger m-1">New Password and Confirm Password doesn't match!</p>
                          )}
                          <button type="submit" className="btn  login-button w-100 waves-effect waves-light">
                            Reset
                          </button>
                        </form>
                      </div>) : null))))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div>
        <Modal
          className="modal-top"
          show={showOtp}
          onHide={handleClose}
          backdrop="static"
          animation={false}
          centered
        >
          <ModalHeader >
            <ModalTitle>
              <p className="mb-0">OTP was sent to your</p>
              <p>registered mobile number</p>
            </ModalTitle>
          </ModalHeader>
          <ModalBody closeButton>
            <form
              onSubmit={(e) => {
                handleValidate(e);
              }}
            >
              <label for="otpInput">Enter OTP:</label>
              <div className="d-flex gap-1 mt-1">
                <AuthCode
                  onChange={handleOnChange}
                  length={4}
                  allowedCharacters="numeric"
                  inputClassName="otp-input"
                />
              </div>
              <p className="text-danger m-1">
                {showOtpError ? "Enter valid Otp" : null}
              </p>
              <p>Otp Attempts Remaining : {frequency}</p>
              <button type="submit" className="btn btn-primary mt-3 w-100">
                Validate
              </button>
            </form>
          </ModalBody>
        </Modal>
      </div>


    </>
  );
}

export default Login;
